import { postWithUploadProgress } from './client';

export interface OptimizeResult {
  ok: true;
  converted: boolean;
  /** Present only when converted. */
  filename?: string;
  contentType?: string;
  content?: string;      // base64
  size?: number;
  originalSize: number;
  /** Present when converted is false — why the original was kept. */
  reason?: string;
}

/**
 * One image per call, on purpose: attachments ride as base64 inside the send body against a 32 MiB
 * cap, so two phone photos would not fit in one request — and per-image means real progress.
 *
 * 🚩 `onProgress` reports BYTES SENT (0..1) and nothing else. The server's own work — 0.4 s for
 * JPEG, ~1.2 s for AVIF, plus a HEIC decode where that applies — reports no progress at all, so the
 * caller must show that leg as indeterminate rather than inventing a number for it.
 */
export async function optimizeImage(
  input: { filename: string; format: 'jpeg' | 'avif'; content: string },
  onProgress?: (fraction: number) => void,
) {
  return postWithUploadProgress<OptimizeResult>('/images/optimize', input, onProgress);
}
